
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/inbody-test-procedures",
      function () {
        return require("private-next-pages/learn/inbody-test-procedures/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/inbody-test-procedures"])
      });
    }
  